import React from 'react';
import { useParams } from 'react-router-dom';
import TagsForm from './TagsForm';

const EditTagPage = () => {
    const { id } = useParams();
    return (
        <TagsForm formType='edit' currentTagId={id} />
    );
};

export default EditTagPage;

